export { default } from './LogoTile';
export type { LogoTileProps } from './LogoTile';
